import React, { useEffect } from 'react';
import { api } from '../services/api';
import { getHostKind, getOrigins } from '../utils/host';
import { getStoredItem, removeStoredItem } from '../utils/storage';

const Logout = () => {
  useEffect(() => {
    let cancelled = false;
    const completeLogout = async () => {
      const refreshToken = getStoredItem('refresh_token');
      if (refreshToken) {
        try {
          await api.post('/acct-mgmt/v1/auth/logout', { refresh_token: refreshToken });
        } catch (err) {
          // This route is used for relying-party logout callbacks; finish locally even if the API call fails.
        }
      }
      removeStoredItem('access_token');
      removeStoredItem('refresh_token');
      removeStoredItem('refresh_expires_at');
      removeStoredItem('session_expiry_warning_seconds');
      if (cancelled) return;
      const { idOrigin } = getOrigins();
      const redirectUrl = new URL(`${idOrigin}/login`);
      redirectUrl.searchParams.set('return_to', getHostKind() === 'ops' ? 'ops' : 'account');
      redirectUrl.searchParams.set('logged_out', '1');
      window.location.replace(redirectUrl.toString());
    };
    completeLogout();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center flex-grow-1">
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status" aria-label="Signing out" />
        <div>Signing out...</div>
      </div>
    </div>
  );
};

export default Logout;
